<script lang="ts">
  import { Alert, Title, Input, ConfirmActions } from '$shared/components';
  import type { AlertDetailedInfo } from '$shared/models/AlertDetailedInfo';
  import { AlertOption } from '$shared/models/AlertOption';
  import { onMount } from 'svelte';

  interface Props {
    value?: string;
    error?: AlertDetailedInfo | string;
    onnext?: (folderName: string) => void;
    oncloseerror?: () => void;
    oncancel?: () => void;
  }

  let { value = '', error = '', onnext, oncloseerror, oncancel }: Props = $props();

  let folderName = $state('');

  let disabled = $derived(!folderName.trim());

  onMount(() => {
    folderName = value;
  });

  const onInputChange = (detail: { value: string }): void => {
    folderName = detail.value?.trim() || '';
  };

  const onClickNext = (): void => {
    onnext?.(folderName);
  };

  const onClickCloseError = (): void => {
    oncloseerror?.();
  };
</script>

<div class="get-folder-name">
  <div class="title"><Title name="title" type="h2">New folder</Title></div>
  {#if error}
    <div class="error">
      <Alert
        maxWidth
        closable
        data={error}
        options={AlertOption.errorAlert()}
        onclose={onClickCloseError}
      />
    </div>
  {/if}
  <div class="input">
    <Input
      placeholder="Folder Name"
      name="folderInput"
      value={folderName}
      oninput={onInputChange}
    />
  </div>
  <div class="actions">
    <ConfirmActions {disabled} reverse okLabel="Next" onok={onClickNext} {oncancel} />
  </div>
</div>

<style>
  .error {
    margin-top: 16px;
  }
  .input {
    margin-top: 16px;
  }
  .actions {
    margin-top: 24px;
  }
</style>
